/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpdateOrganizationPaymentCurrentPlanResponseDataFromJSON, UpdateOrganizationPaymentCurrentPlanResponseDataToJSON } from './UpdateOrganizationPaymentCurrentPlanResponseData';
export function UpdateOrganizationPaymentCurrentPlanResponseFromJSON(json) {
    return UpdateOrganizationPaymentCurrentPlanResponseFromJSONTyped(json, false);
}
export function UpdateOrganizationPaymentCurrentPlanResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: json['status'],
        data: UpdateOrganizationPaymentCurrentPlanResponseDataFromJSON(json['data'])
    };
}
export function UpdateOrganizationPaymentCurrentPlanResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: UpdateOrganizationPaymentCurrentPlanResponseDataToJSON(value.data)
    };
}
